import React, { useState, useEffect } from 'react';
import { Phone, Edit2, Trash2, Plus, CheckCircle2, XCircle, Search, KeyRound, Send, LifeBuoy, AlertCircle, Maximize2, Minimize2 } from 'lucide-react';
import api from '../services/api';

// NOVO: traduz as mensagens de bloqueio que a Meta manda em ingles (block_reason).
// Usa um dicionario com as mensagens mais comuns; se a Meta mandar algo novo que
// ainda nao mapeamos, mostra o texto original em vez de esconder a informacao.
const BLOCK_REASON_TRANSLATIONS = [
  {
    match: /error with the payment method/i,
    text: 'Há um erro na forma de pagamento. Isso vai bloquear conversas iniciadas pela empresa.',
    actionUrl: 'https://business.facebook.com/billing_hub/payment_methods',
    actionLabel: 'Corrigir forma de pagamento'
  },
  {
    match: /has not passed business verification/i,
    text: 'O negócio ainda não passou pela verificação da Meta (Business Verification).',
    actionUrl: 'https://business.facebook.com/settings/security',
    actionLabel: 'Verificar negócio'
  },
  {
    match: /account.*restrict/i,
    text: 'A conta foi restringida pela Meta.'
  },
  {
    match: /violat/i,
    text: 'Foi identificada uma violação das políticas da Meta/WhatsApp.'
  }
];

function translateBlockReason(reason) {
  if (!reason) return reason;
  const found = BLOCK_REASON_TRANSLATIONS.find(({ match }) => match.test(reason));
  return found ? found.text : reason;
}

function getBlockReasonAction(reason) {
  if (!reason) return null;
  const found = BLOCK_REASON_TRANSLATIONS.find(({ match }) => match.test(reason));
  return found?.actionUrl ? { url: found.actionUrl, label: found.actionLabel || 'Abrir no Meta Business' } : null;
}


export default function PhoneNumbers() {
  const [numbers, setNumbers] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState('');
  const [filterSector, setFilterSector] = useState('');
  
  // Estados para modal OTP
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpTarget, setOtpTarget] = useState(null);
  const [otpCode, setOtpCode] = useState('');
  const [otpMethod, setOtpMethod] = useState('SMS');
  const [alreadyVerified, setAlreadyVerified] = useState(false); // ⭐ NOVO
  const [loadingOtp, setLoadingOtp] = useState(false);

  const [form, setForm] = useState({
    phone_number_id: '',
    display_number: '',
    sector_id: '',
    business_id: ''
  });

  const [availableNumbers, setAvailableNumbers] = useState([]);
  const [businesses, setBusinesses] = useState([]); // ⭐ NOVO: empresas/WABAs conectadas
  const [qualityMap, setQualityMap] = useState({}); // { numberId: { quality_rating, throughput_level } }
  const [usageMap, setUsageMap] = useState({}); // ⭐ NOVO: { numberId: { used, limit, remaining, percent } } — mensagens de serviço no mês

  // ⭐ NOVO: liga/desliga o limitador diário de disparo em massa por número
  const handleToggleCampaignLimit = async (numberId, currentlyEnabled) => {
    try {
      await api.put(`/api/phone-numbers/${numberId}/campaign-limit`, { enabled: !currentlyEnabled });
      setNumbers(prev => prev.map(n => n.id === numberId ? { ...n, campaign_limit_enabled: !currentlyEnabled } : n));
    } catch (err) {
      alert('Erro ao atualizar limitador: ' + (err.response?.data?.error || err.message));
    }
  };
  const [expandedCards, setExpandedCards] = useState({}); // { numberId: true/false }
  const [users, setUsers] = useState([]);
  const [allocations, setAllocations] = useState({}); // { user_id: percentage }
  const [savingAllocations, setSavingAllocations] = useState(false);  

  useEffect(() => {
    loadData();
  }, []);
        
      const loadData = async () => {
    try {
      const [numbersRes, sectorsRes, usersRes, businessesRes] = await Promise.all([
        api.get('/api/phone-numbers'),
        api.get('/api/sectors'),
        api.get('/api/users'),
        api.get('/api/businesses')
      ]);
      setNumbers(numbersRes.data);
      setSectors(sectorsRes.data);
      setAvailableNumbers(numbersRes.data);
      setUsers(usersRes.data);
      setBusinesses(businessesRes.data);
      console.log('📞 Números recebidos:', numbersRes.data);

      // ⭐ NOVO: busca a qualidade de cada número direto na Meta, sem travar a tela
      numbersRes.data.forEach(n => {
        if (n.waba_id) {
          api.get(`/api/phone-numbers/${n.id}/meta-status`)
            .then(res => {
              setQualityMap(prev => ({ ...prev, [n.id]: res.data }));
            })
            .catch(() => {});
        }
        // ⭐ NOVO: uso de mensagens de serviço no mês (limite de 1.000 grátis por número)
        api.get(`/api/phone-numbers/${n.id}/service-usage`)
          .then(res => {
            setUsageMap(prev => ({ ...prev, [n.id]: res.data }));
          })
          .catch(() => {});
      });
    } catch (err) {
        console.error('Erro ao carregar dados:', err);
      alert('Erro ao carregar dados: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/api/phone-numbers/${editing.id}`, form);
        alert('✅ Número atualizado com sucesso!');
      } else {
        const existingNumber = numbers.find(n => n.phone_number_id === form.phone_number_id);
        if (existingNumber) {
          await api.put(`/api/phone-numbers/${existingNumber.id}`, {
            sector_id: form.sector_id,
            display_number: form.display_number || existingNumber.display_number
          });
          alert('✅ Número vinculado ao setor com sucesso!');
        } else {
          await api.post('/api/phone-numbers', form);
          alert('✅ Número adicionado com sucesso!');
        }
      }
      setShowModal(false);
      setEditing(null);
      setForm({ phone_number_id: '', display_number: '', sector_id: '', business_id: '' });
      loadData();
    } catch (err) {
      const errorData = err.response?.data;
      alert('Erro: ' + (errorData?.error || err.message));
    }
  };

    const handleEdit = async (number) => {
    setEditing(number);
    setForm({
      phone_number_id: number.phone_number_id,
      display_number: number.display_number,
      sector_id: number.sector_id || '',
      business_id: number.business_id || ''
    });
    setShowModal(true);

    try {
      const res = await api.get(`/api/phone-numbers/${number.id}/allocations`);
      const map = {};
      res.data.forEach(a => { map[a.user_id] = a.percentage; });
      setAllocations(map);
    } catch (err) {
      console.error('Erro ao carregar distribuição:', err);
      setAllocations({});
    }
  };

  const handleSaveAllocations = async () => {
    const entries = Object.entries(allocations)
      .filter(([, pct]) => Number(pct) > 0)
      .map(([user_id, percentage]) => ({ user_id: parseInt(user_id), percentage: Number(percentage) }));

    if (entries.length > 1) {
      const total = entries.reduce((sum, e) => sum + e.percentage, 0);
      if (total !== 100) {
        alert(`Os percentuais precisam somar 100% (soma atual: ${total}%)`);
        return;
      }
    }

    setSavingAllocations(true);
    try {
      await api.put(`/api/phone-numbers/${editing.id}/allocations`, { allocations: entries });
      alert('✅ Distribuição salva!');
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    } finally {
      setSavingAllocations(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Excluir este número?')) {
      try {
        await api.delete(`/api/phone-numbers/${id}`);
        alert('✅ Número excluído com sucesso!');
        loadData();
      } catch (err) {
        alert('Erro ao excluir: ' + (err.response?.data?.error || err.message));
      }
    }
  };

  const handleToggleActive = async (number) => {
    try {
      await api.put(`/api/phone-numbers/${number.id}`, {
        is_active: !number.is_active
      });
      loadData();
    } catch (err) {
      alert('Erro ao alterar status: ' + (err.response?.data?.error || err.message));
    }
  };

  // Funções OTP Meta
  const openOtpModal = (number) => {
    setOtpTarget(number);
    setOtpCode('');
    setOtpMethod('SMS');
    setAlreadyVerified(false);
    setShowOtpModal(true);
  };

  const handleRequestCode = async () => {
    if (!otpTarget) return;
    try {
      setLoadingOtp(true);
      await api.post('/api/auth/whatsapp/request-code', {
        phoneNumberId: otpTarget.phone_number_id,
        wabaId: otpTarget.waba_id,
        method: otpMethod
      });
      alert(`✅ Código enviado com sucesso via ${otpMethod}! Verifique o seu celular.`);
    } catch (err) {
      // ⭐ NOVO: caso "já verificado" (136024/2388366) — não precisa de SMS,
      // pula direto pra etapa de definir o PIN e registrar
      const data = err.response?.data;
      if (data?.metaCode === 136024 || data?.metaSubcode === 2388366) {
        setAlreadyVerified(true);
        alert('ℹ️ Esse número já foi verificado pela Meta antes — não precisa de código por SMS. Defina um PIN de 6 dígitos abaixo e clique em "Registrar" para concluir.');
      } else {
        alert('Erro ao solicitar código: ' + (data?.error || err.message));
      }
    } finally {
      setLoadingOtp(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    if (!otpTarget || otpCode.length !== 6) {
      alert('Digite o código de 6 dígitos válido.');
      return;
    }
    try {
      setLoadingOtp(true);
      // ⭐ NOVO: se já estava verificado, registra direto com PIN (sem SMS)
      if (alreadyVerified) {
        await api.post('/api/auth/whatsapp/register-direct', {
          phoneNumberId: otpTarget.phone_number_id,
          wabaId: otpTarget.waba_id,
          pin: otpCode
        });
      } else {
        await api.post('/api/auth/whatsapp/register', {
          phoneNumberId: otpTarget.phone_number_id,
          wabaId: otpTarget.waba_id,
          code: otpCode
        });
      }
      alert('✅ Número verificado e registrado com sucesso na Meta!');
      setShowOtpModal(false);
      loadData();
    } catch (err) {
      alert('Erro ao verificar código: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoadingOtp(false);
    }
  };

  const filtered = numbers.filter(n => {
    const matchesSearch = 
      n.display_number?.toLowerCase().includes(search.toLowerCase()) ||
      n.display_phone_number?.toLowerCase().includes(search.toLowerCase()) ||
      n.phone_number_id?.toLowerCase().includes(search.toLowerCase()) ||
      n.sector_name?.toLowerCase().includes(search.toLowerCase());
    
    const matchesSector = !filterSector || n.sector_id == filterSector;
    return matchesSearch && matchesSector;
  });

  const stats = {
    total: numbers.length,
    active: numbers.filter(n => n.is_active).length,
    inactive: numbers.filter(n => !n.is_active).length
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Números de WhatsApp</h1>
          <p className="text-gray-500">Gerencie os números, verificação OTP e setores</p>
        </div>
        <div className="flex items-center gap-3">
          {/* ⭐ NOVO: atalho pro suporte oficial da Meta — não é integração de
              verdade (a Meta não oferece API pra isso), só abre o painel deles
              numa aba nova, contextual aos problemas de qualidade/restrição
              que aparecem nesta mesma tela */}
          <a
            href="https://business.facebook.com/business/help"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-50"
            title="Abre o suporte da Meta em uma nova aba"
          >
            <LifeBuoy size={18} className="text-blue-500" /> Suporte Meta
          </a>
          <button 
            onClick={() => { 
              setEditing(null); 
              setForm({ phone_number_id: '', display_number: '', sector_id: '', business_id: '' }); 
              setShowModal(true); 
            }}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-xl font-medium hover:bg-green-700 shadow-lg shadow-green-100">
            <Plus size={18} /> Adicionar Número
          </button>
        </div>
      </div>

      {/* CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-gray-500">Total de Números</p>
              <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
            </div>
            <Phone size={24} className="text-gray-400" />
          </div>
        </div>
        <div className="bg-gradient-to-br from-green-50 to-green-100 p-4 rounded-2xl border border-green-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-green-700">Números Ativos</p>
              <p className="text-2xl font-bold text-green-900">{stats.active}</p>
            </div>
            <CheckCircle2 size={24} className="text-green-600" />
          </div>
        </div>
        <div className="bg-gradient-to-br from-amber-50 to-amber-100 p-4 rounded-2xl border border-amber-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-amber-700">Pendentes / Inativos</p>
              <p className="text-2xl font-bold text-amber-900">{stats.inactive}</p>
            </div>
            <XCircle size={24} className="text-amber-600" />
          </div>
        </div>
      </div>

      {/* FILTROS */}
      <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              placeholder="Buscar por nome, ID ou setor..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>
          <select
            value={filterSector}
            onChange={e => setFilterSector(e.target.value)}
            className="px-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none"
          >
            <option value="">Todos os setores</option>
            {sectors.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>
      </div>

      {/* LISTA DE NÚMEROS */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map(number => (
          <div key={number.id} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
            <div className="flex items-start justify-between mb-4">
              <div className={`p-3 rounded-xl ${number.is_active ? 'bg-green-50 text-green-600' : 'bg-amber-50 text-amber-600'}`}>
                <Phone size={24} />
              </div>
              <div className="flex gap-2">
                <button 
                  onClick={() => handleToggleActive(number)}
                  className={`p-1.5 rounded-lg transition-colors ${
                    number.is_active ? 'text-green-600 hover:bg-green-50' : 'text-amber-600 hover:bg-amber-50'
                  }`}
                  title={number.is_active ? 'Desativar' : 'Ativar'}
                >
                  {number.is_active ? <CheckCircle2 size={16} /> : <XCircle size={16} />}
                </button>
                <button onClick={() => handleEdit(number)} className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg" title="Editar">
                  <Edit2 size={16} />
                </button>
                <button onClick={() => handleDelete(number.id)} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg" title="Excluir">
                  <Trash2 size={16} />
                </button>
                <button
                  onClick={() => setExpandedCards(prev => ({ ...prev, [number.id]: !prev[number.id] }))}
                  className="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg"
                  title={expandedCards[number.id] ? 'Recolher' : 'Expandir'}
                >
                  {expandedCards[number.id] ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
                </button>
              </div>
            </div>
            
            <h3 className="font-bold text-gray-900 text-lg mb-1">
              {number.display_phone_number || number.display_name}
            </h3>
            <p className="text-xs text-gray-500 mb-3 font-mono truncate">{number.phone_number_id}</p>
            
            <div className="space-y-2 text-sm mb-4">
              <div className="flex justify-between">
                <span className="text-gray-500">Setor:</span>
                <span className="font-medium text-gray-900">{number.sector_name || 'Não vinculado'}</span>
              </div>
              {/* ⭐ CORRIGIDO: "verificado" (posse do número confirmada) e "registrado
                  na API" (pronto pra enviar/receber mensagem) são etapas diferentes na
                  Meta — antes uma etiqueta só misturava as duas e podia mostrar "Ativo"
                  sem realmente estar pronto pra uso */}
              <div className="flex justify-between">
                <span className="text-gray-500">Verificado (Meta):</span>
                <span className={`font-medium ${number.meta_verified ? 'text-green-600' : 'text-gray-400'}`}>
                  {number.meta_verified ? '✓ Sim' : '— Não'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">Registrado na API:</span>
                <span className={`font-medium ${number.is_active ? 'text-green-600' : 'text-amber-600'}`}>
                  {number.is_active ? '✓ Ativo' : '⚠ Pendente (OTP)'}
                </span>
              </div>
              {/* ⭐ NOVO: qualidade do número, direto da Meta */}
              {qualityMap[number.id]?.quality_rating && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Qualidade:</span>
                  <span className={`flex items-center gap-1.5 font-medium px-2 py-0.5 rounded-full text-xs ${
                    qualityMap[number.id].quality_rating === 'GREEN' ? 'bg-green-50 text-green-700' :
                    qualityMap[number.id].quality_rating === 'YELLOW' ? 'bg-yellow-50 text-yellow-700' :
                    qualityMap[number.id].quality_rating === 'RED' ? 'bg-red-50 text-red-700' :
                    'bg-gray-50 text-gray-500'
                  }`}>
                    <span className={`w-2 h-2 rounded-full ${
                      qualityMap[number.id].quality_rating === 'GREEN' ? 'bg-green-500' :
                      qualityMap[number.id].quality_rating === 'YELLOW' ? 'bg-yellow-500' :
                      qualityMap[number.id].quality_rating === 'RED' ? 'bg-red-500' :
                      'bg-gray-400'
                    }`} />
                    {qualityMap[number.id].quality_rating === 'GREEN' ? 'Alta' :
                     qualityMap[number.id].quality_rating === 'YELLOW' ? 'Média' :
                     qualityMap[number.id].quality_rating === 'RED' ? 'Baixa' :
                     qualityMap[number.id].quality_rating}
                  </span>
                </div>
              )}
              {/* ⭐ NOVO: nível de capacidade de envio (padrão/alta) e status da
                  verificação OTP — já eram buscados na Meta mas não apareciam no card */}
              {qualityMap[number.id]?.throughput_level && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Capacidade:</span>
                  <span className="text-gray-900 font-medium">
                    {qualityMap[number.id].throughput_level === 'STANDARD' ? 'Padrão' :
                     qualityMap[number.id].throughput_level === 'HIGH' ? 'Alta' :
                     qualityMap[number.id].throughput_level}
                  </span>
                </div>
              )}
              {qualityMap[number.id]?.business_verification_status && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Negócio Verificado:</span>
                  <span className={`font-medium px-2 py-0.5 rounded-full text-xs ${
                    qualityMap[number.id].business_verification_status === 'verified' ? 'bg-green-50 text-green-700' :
                    'bg-red-50 text-red-700'
                  }`}>
                    {qualityMap[number.id].business_verification_status === 'verified' ? 'Sim' :
                     qualityMap[number.id].business_verification_status === 'pending' ? 'Pendente' :
                     qualityMap[number.id].business_verification_status === 'not_verified' ? 'Não verificado' :
                     qualityMap[number.id].business_verification_status === 'rejected' ? 'Rejeitado' :
                     qualityMap[number.id].business_verification_status}
                  </span>
                </div>
              )}
              {qualityMap[number.id]?.messaging_limit_tier && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Limite Diário:</span>
                  <span className="text-gray-900 font-medium">
                    {({
                      TIER_50: '50', TIER_250: '250', TIER_1K: '1.000', TIER_2K: '2.000',
                      TIER_10K: '10.000', TIER_100K: '100.000', TIER_UNLIMITED: 'Ilimitado',
                      TIER_NOT_SET: 'Não definido'
                    })[qualityMap[number.id].messaging_limit_tier] || qualityMap[number.id].messaging_limit_tier}
                  </span>
                </div>
              )}
              {/* NOVO: alerta proativo quando o limite diario vem vazio da Meta —
                  isso normalmente fica "sumido" no card sem nenhuma explicacao,
                  entao ligamos os pontos com o status de verificacao do negocio */}
              {qualityMap[number.id] && !qualityMap[number.id].messaging_limit_tier && (
                <div className="mt-1 p-2.5 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-800">
                  <p className="font-semibold flex items-center gap-1.5">
                    <AlertCircle size={13} className="flex-shrink-0" />
                    Limite diário não definido
                  </p>
                  {qualityMap[number.id].business_verification_status &&
                   qualityMap[number.id].business_verification_status !== 'verified' ? (
                    <p className="mt-1">
                      Isso costuma acontecer quando o negócio ainda não passou pela verificação
                      da Meta. Verifique o status de "Negócio Verificado" acima e conclua a
                      verificação no Business Manager para liberar o limite normal de envio.
                    </p>
                  ) : (
                    <p className="mt-1">
                      A Meta não retornou um limite diário para este número. Isso pode ser
                      temporário — se persistir, verifique o status geral do número no
                      Business Manager.
                    </p>
                  )}
                </div>
              )}
              {/* ⭐ NOVO: mensagens de serviço (resposta de atendimento) usadas no mês —
                  a Meta passa a cobrar depois de 1.000 grátis por número a partir de
                  01/10/2026 (antes disso era ilimitado e grátis) */}
              {usageMap[number.id] && (
                <div className="mt-1">
                  <div className="flex justify-between items-center mb-1">
                    <span className="text-gray-500">Msgs. de serviço (mês):</span>
                    <span className={`font-medium ${
                      usageMap[number.id].percent >= 90 ? 'text-red-600' :
                      usageMap[number.id].percent >= 70 ? 'text-amber-600' : 'text-gray-900'
                    }`}>
                      {usageMap[number.id].used.toLocaleString('pt-BR')} / {usageMap[number.id].limit.toLocaleString('pt-BR')}
                    </span>
                  </div>
                  <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full ${
                        usageMap[number.id].percent >= 90 ? 'bg-red-500' :
                        usageMap[number.id].percent >= 70 ? 'bg-amber-500' : 'bg-green-500'
                      }`}
                      style={{ width: `${usageMap[number.id].percent}%` }}
                    />
                  </div>
                </div>
              )}
              {/* ⭐ NOVO: limitador diário de disparo em massa — liga/desliga por
                  número, baseado na qualidade atual (Baixa=200, Média=1.000, Alta=sem limite) */}
              <div className="mt-1 flex items-center justify-between">
                <div>
                  <span className="text-gray-500">Limitar disparo em massa:</span>
                  {number.campaign_limit_enabled && (
                    <p className="text-xs text-gray-400 mt-0.5">
                      {({ RED: '200/dia (qualidade baixa)', YELLOW: '1.000/dia (qualidade média)', GREEN: 'sem limite (qualidade alta)' })[qualityMap[number.id]?.quality_rating] || 'aguardando qualidade da Meta'}
                    </p>
                  )}
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0 ml-2">
                  <input
                    type="checkbox"
                    checked={!!number.campaign_limit_enabled}
                    onChange={() => handleToggleCampaignLimit(number.id, number.campaign_limit_enabled)}
                    className="sr-only peer"
                  />
                  <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:bg-green-500 transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-4"></div>
                </label>
              </div>
              {qualityMap[number.id]?.code_verification_status && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Verificação OTP:</span>
                  <span className={`font-medium ${
                    qualityMap[number.id].code_verification_status === 'VERIFIED' ? 'text-green-700' : 'text-gray-900'
                  }`}>
                    {qualityMap[number.id].code_verification_status === 'VERIFIED' ? 'Verificado' :
                     qualityMap[number.id].code_verification_status === 'NOT_VERIFIED' ? 'Não verificado' :
                     qualityMap[number.id].code_verification_status === 'EXPIRED' ? 'Expirado' :
                     qualityMap[number.id].code_verification_status}
                  </span>
                </div>
              )}
              {/* ⭐ NOVO: avisos de violação de política nos últimos 90 dias — sinal
                  complementar à qualidade, que só reflete as últimas 24h */}
              {qualityMap[number.id]?.violation_count_90d > 0 && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Avisos (90d):</span>
                  <span className="flex items-center gap-1.5 font-medium px-2 py-0.5 rounded-full text-xs bg-orange-50 text-orange-700">
                    <span className="w-2 h-2 rounded-full bg-orange-500" />
                    {qualityMap[number.id].violation_count_90d}
                  </span>
                </div>
              )}
              {/* ⭐ NOVO: status de envio AGORA, consultado direto na Meta (health_status) —
                  diferente de qualidade/avisos, isso mostra se está bloqueado neste momento */}
              {qualityMap[number.id]?.can_send_message && (
                <div className="flex justify-between items-start">
                  <span className="text-gray-500">Pode Enviar:</span>
                  <span className="text-right">
                    <span className={`inline-flex items-center gap-1.5 font-medium px-2 py-0.5 rounded-full text-xs ${
                      qualityMap[number.id].can_send_message === 'AVAILABLE' ? 'bg-green-50 text-green-700' :
                      qualityMap[number.id].can_send_message === 'LIMITED' ? 'bg-yellow-50 text-yellow-700' :
                      'bg-red-50 text-red-700'
                    }`}>
                      <span className={`w-2 h-2 rounded-full ${
                        qualityMap[number.id].can_send_message === 'AVAILABLE' ? 'bg-green-500' :
                        qualityMap[number.id].can_send_message === 'LIMITED' ? 'bg-yellow-500' :
                        'bg-red-500'
                      }`} />
                      {qualityMap[number.id].can_send_message === 'AVAILABLE' ? 'Sim' :
                       qualityMap[number.id].can_send_message === 'LIMITED' ? 'Limitado' :
                       'Bloqueado'}
                    </span>
                  </span>
                </div>
              )}
            </div>

            {expandedCards[number.id] && (
              <div className="border-t border-gray-100 pt-3 space-y-3">
                {number.waba_id && (
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">WABA ID:</span>
                    <span className="font-medium text-gray-900 text-xs truncate max-w-[150px]">
                      {number.waba_id}
                    </span>
                  </div>
                )}
                {qualityMap[number.id]?.block_reason && (
                  <div className="text-[11px] text-red-600">
                    {translateBlockReason(qualityMap[number.id].block_reason)}
                    {getBlockReasonAction(qualityMap[number.id].block_reason) && (
                      <a
                        href={getBlockReasonAction(qualityMap[number.id].block_reason).url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ml-1 inline-block text-[11px] font-semibold text-blue-600 hover:text-blue-800 hover:underline"
                      >
                        {getBlockReasonAction(qualityMap[number.id].block_reason).label} →
                      </a>
                    )}
                  </div>
                )}
                {/* ⭐ CORRIGIDO: antes só aparecia se is_active=false no nosso banco,
                mas "verificado" (Meta) e "registrado na API" são coisas diferentes —
                agora sempre disponível, pra poder (re)registrar quando a Meta pedir */}
            <button
              onClick={() => openOtpModal(number)}
              className="w-full flex items-center justify-center gap-2 py-2 px-3 bg-amber-50 border border-amber-200 text-amber-700 rounded-xl text-sm font-semibold hover:bg-amber-100 transition-colors"
            >
              <KeyRound size={16} /> Verificar/Registrar Número (OTP)
            </button>
              </div>
            )}
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full text-center py-12">
            <Phone size={48} className="mx-auto mb-3 text-gray-300" />
            <p className="text-gray-400 text-lg font-medium">
              {search || filterSector ? 'Nenhum número encontrado com esses filtros' : 'Nenhum número cadastrado'}
            </p>
          </div>
        )}
      </div>

      {/* MODAL PRINCIPAL (Adicionar / Editar) */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl max-h-[90vh] overflow-y-auto">
            <h2 className="text-lg font-bold mb-4">
              {editing ? 'Editar Número' : 'Adicionar / Vincular Número'}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              {!editing && (
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Selecionar Número Existente
                  </label>
                  <select
                    value={form.phone_number_id}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      if (!selectedId) {
                        setForm({...form, phone_number_id: '', display_number: ''});
                        return;
                      }
                      const selectedNumber = numbers.find(n => n.phone_number_id === selectedId);
                      if (selectedNumber) {
                        setForm({
                          ...form,
                          phone_number_id: selectedNumber.phone_number_id,
                          display_number: selectedNumber.display_number,
                          business_id: selectedNumber.business_id || ''
                        });
                      }
                    }}
                    className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none"
                  >
                    <option value="">Selecione um número</option>
                    {availableNumbers.map(n => (
                      <option key={n.id} value={n.phone_number_id}>
                        {n.display_number} ({n.phone_number_id})
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* ⭐ NOVO: qual empresa/WABA esse número pertence — essencial quando
                  você tem contas Meta separadas por setor (evita enviar pelo token errado) */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Empresa / Conta WhatsApp (WABA) *
                </label>
                <select
                  value={form.business_id}
                  onChange={e => setForm({...form, business_id: e.target.value})}
                  required
                  className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none"
                >
                  <option value="">Selecione a empresa/WABA</option>
                  {businesses.map(b => (
                    <option key={b.id} value={b.id}>
                      {b.profile_name || b.waba_id} ({b.waba_id})
                    </option>
                  ))}
                </select>
                {businesses.length === 0 && (
                  <p className="text-[11px] text-amber-600 mt-1">
                    Nenhuma empresa conectada ainda — conecte uma em "Contas Business" antes de adicionar o número.
                  </p>
                )}
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Phone Number ID (Meta) *
                </label>
                <input 
                  type="text" 
                  placeholder="Ex: 123456789012345" 
                  value={form.phone_number_id} 
                  onChange={e => setForm({...form, phone_number_id: e.target.value})} 
                  required
                  className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none" 
                  disabled={!!editing}
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Nome de Exibição *
                </label>
                <input 
                  type="text" 
                  placeholder="Ex: Suporte, Vendas" 
                  value={form.display_number} 
                  onChange={e => setForm({...form, display_number: e.target.value})} 
                  required
                  className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none" 
                />
              </div>
              
                            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Setor
                </label>
                <select 
                  value={form.sector_id} 
                  onChange={e => setForm({...form, sector_id: e.target.value})}
                  className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none"
                >
                  <option value="">Selecione um setor</option>
                  {sectors.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
              </div>

              {/* ⭐ NOVO: distribuição de mensagens por atendente (só ao editar um número já salvo) */}
              {editing && form.sector_id && (
                <div className="border-t border-gray-100 pt-4">
                  <label className="block text-xs font-medium text-gray-700 mb-2">
                    Distribuição de Mensagens por Atendente (%)
                  </label>
                  {users.filter(u => String(u.sector_id) === String(form.sector_id) && ['attendant', 'manager'].includes(u.role)).length === 0 ? (
                    <p className="text-xs text-gray-400">Nenhum atendente nesse setor ainda.</p>
                  ) : (
                    <div className="space-y-2">
                      {users.filter(u => String(u.sector_id) === String(form.sector_id) && ['attendant', 'manager'].includes(u.role)).map(u => (
                        <div key={u.id} className="flex items-center justify-between gap-3 bg-gray-50 rounded-lg px-3 py-2">
                          <span className="text-sm text-gray-700 truncate">{u.name}</span>
                          <div className="flex items-center gap-1">
                            <input
                              type="number"
                              min="0"
                              max="100"
                              value={allocations[u.id] || ''}
                              onChange={e => setAllocations({ ...allocations, [u.id]: e.target.value })}
                              placeholder="0"
                              className="w-16 p-1.5 border border-gray-200 rounded-lg text-sm text-right"
                            />
                            <span className="text-xs text-gray-400">%</span>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={handleSaveAllocations}
                        disabled={savingAllocations}
                        className="w-full mt-2 px-3 py-2 bg-blue-50 text-blue-700 rounded-lg text-xs font-bold hover:bg-blue-100 disabled:opacity-50"
                      >
                        {savingAllocations ? 'Salvando...' : 'Salvar Distribuição'}
                      </button>
                      <p className="text-[10px] text-gray-400 mt-1">
                        💡 Com apenas 1 atendente definido, ele recebe 100% das mensagens desse número. Com 2 ou mais, a soma dos percentuais precisa dar 100%.
                      </p>
                    </div>
                  )}
                </div>
              )}

              <div className="flex gap-3 justify-end pt-2">
                <button 
                  type="button" 
                  onClick={() => { setShowModal(false); setEditing(null); }}
                  className="px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="px-5 py-2 bg-green-600 text-white rounded-xl text-sm font-bold hover:bg-green-700"
                >
                  {editing ? 'Salvar Alterações' : 'Adicionar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL DE VERIFICAÇÃO OTP (META API) */}
      {showOtpModal && otpTarget && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl">
            <h2 className="text-lg font-bold mb-2 flex items-center gap-2">
              <KeyRound className="text-amber-600" size={20} /> Ativação de Segurança (OTP)
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Para ativar o número <strong>{otpTarget.display_phone_number || otpTarget.display_number}</strong> na Meta, solicite o código via SMS ou Ligação e digite abaixo.
            </p>

            <div className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Método de Envio</label>
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={() => setOtpMethod('SMS')}
                    className={`flex-1 py-2 rounded-xl text-xs font-bold border transition-all ${
                      otpMethod === 'SMS' ? 'bg-green-50 border-green-500 text-green-700' : 'border-gray-200 text-gray-600'
                    }`}
                  >
                    Receber por SMS
                  </button>
                  <button
                    type="button"
                    onClick={() => setOtpMethod('VOICE')}
                    className={`flex-1 py-2 rounded-xl text-xs font-bold border transition-all ${
                      otpMethod === 'VOICE' ? 'bg-green-50 border-green-500 text-green-700' : 'border-gray-200 text-gray-600'
                    }`}
                  >
                    Receber por Ligação
                  </button>
                </div>
              </div>

              {alreadyVerified ? (
                <div className="flex items-start gap-2 p-3 bg-blue-50 border border-blue-200 rounded-xl text-xs text-blue-800">
                  <span>ℹ️ Esse número já foi verificado pela Meta antes. Não precisa de código por SMS — só definir um PIN de 6 dígitos abaixo e registrar.</span>
                </div>
              ) : (
                <button
                  type="button"
                  disabled={loadingOtp}
                  onClick={handleRequestCode}
                  className="w-full flex items-center justify-center gap-2 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-bold hover:bg-blue-700 disabled:opacity-50"
                >
                  <Send size={16} /> {loadingOtp ? 'Enviando...' : `Solicitar Código (${otpMethod})`}
                </button>
              )}

              <form onSubmit={handleVerifyCode} className="space-y-3 pt-3 border-t">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    {alreadyVerified ? 'Defina um PIN de 6 Dígitos' : 'Código de Verificação de 6 Dígitos'}
                  </label>
                  <input
                    type="text"
                    maxLength="6"
                    placeholder="000000"
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                    className="w-full p-2.5 text-center text-xl font-mono tracking-widest border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 outline-none"
                    required
                  />
                </div>

                <div className="flex gap-3 justify-end pt-2">
                  <button
                    type="button"
                    onClick={() => setShowOtpModal(false)}
                    className="px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50"
                  >
                    Fechar
                  </button>
                  <button
                    type="submit"
                    disabled={loadingOtp || otpCode.length !== 6}
                    className="px-5 py-2 bg-green-600 text-white rounded-xl text-sm font-bold hover:bg-green-700 disabled:opacity-50"
                  >
                    {loadingOtp ? 'Verificando...' : 'Verificar e Ativar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
